export default {
  config: {
    style: {
      label: "编写样式(待完善)",
      type: "codemirror", // 只需要在这里指定为 codemirror 即可
      attrs: {
        // 属性配置(会覆盖全局配置)
        options: {
          tabSize: 2,
          mode: "text/css",
          lineNumbers: true,
          line: true
        }
      }
    }
  },
  data: {}
};
